module.exports = __webpack_public_path__ + "img/9788963717586.49c01766.jpg";